import { render, staticRenderFns } from "./Butterfly.vue?vue&type=template&id=806cdd46&scoped=true"
import script from "./Butterfly.vue?vue&type=script&lang=js"
export * from "./Butterfly.vue?vue&type=script&lang=js"
import style0 from "./Butterfly.vue?vue&type=style&index=0&id=806cdd46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "806cdd46",
  null
  
)

export default component.exports